<div class="registration-details-view-container" *ngIf="registrationObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="id-info">
    <mat-form-field appearance="fill" color="accent">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" [disabled]="true" [value]="registrationObject.recordId?.toString()">
    </mat-form-field>
  </div>

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + registrationObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="registrationObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).registration.write" (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
<!--    <button [disabled]="!(userPermissions | async).registration.delete" (click)="delete()" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>-->
    <button [disabled]="!(userPermissions | async).meeting.read_and_sign_up || !canRegisterToExam" (click)="registerToExam()" mat-stroked-button color="accent"><span>Zapisz na egzamin</span></button>

    <button [class.spinner]="generatingDocument" mat-stroked-button [matMenuTriggerFor]="generate"><mat-icon>content_copy</mat-icon> Wygeneruj</button>
    <mat-menu #generate="matMenu">
      <button mat-menu-item [disabled]="!(userPermissions | async).registration.read || generatingDocument" (click)="generateStatements()">Oświadczenia</button>
      <button mat-menu-item [disabled]="!(userPermissions | async).contract.write || generatingDocument" (click)="generateAuthorization()">Upoważnienie</button>
    </mat-menu>

    <button [class.spinner]="generatingDocument" [disabled]="!(userPermissions | async).registration.create" mat-stroked-button [matMenuTriggerFor]="deregister">Do wyrejestrowania</button>

    <mat-menu #deregister="matMenu">
      <button mat-menu-item (click)="deregisterRegistration()">Tylko w tym TU</button>
      <button mat-menu-item (click)="deregisterAllRegistration()">We wszystkich TU</button>
    </mat-menu>

    <button [class.spinner]="generatingDocument" [disabled]="!(userPermissions | async).registration.create" mat-stroked-button [matMenuTriggerFor]="blocking">Do zablokowania</button>

    <mat-menu #blocking="matMenu">
      <button mat-menu-item (click)="blockRegistration()">Tylko w tym TU</button>
      <button mat-menu-item (click)="blockAllRegistration()">We wszystkich TU</button>
    </mat-menu>
    <button mat-stroked-button [matMenuTriggerFor]="menu" aria-label="Menu" color="primary">
      <mat-icon>settings</mat-icon>
    </button>
    <mat-menu #menu="matMenu">

      <button [disabled]="!(userPermissions | async).registration.delete" (click)="delete()" mat-menu-item color="warn"
      ><mat-icon>delete</mat-icon> <span> Usuń</span></button>


    </mat-menu>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane rejestracji</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="OFWCA" [value]="registrationObject.ofwca?.fullName"
                          [link]="['/ofwca/szczegoly', registrationObject.ofwca?.uuid]"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Umowa"
                          [value]="registrationObject.contract.type.name + ' (nr: ' + registrationObject.contract.number + '), '
                          + registrationObject.contract.status.name"
                          [link]="registrationObject.contract ? ['/umowy/szczegoly', registrationObject.contract.uuid] : undefined">
              </app-detail>
            </div>

            <div fxLayout="row" *ngIf="registrationObject.contract.partner">
              <app-detail fxFlex="100" header="Partner"
                          [value]="registrationObject.contract.partner.shortName"
                          [link]="['/partnerzy/szczegoly', registrationObject.contract.partner.uuid]">
              </app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="TU" [value]="registrationObject.insuranceCompany?.name"
                          [link]="['/tu/szczegoly', registrationObject.insuranceCompany?.id]"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="50" header="Co jest potrzebne?" [value]="registrationObject.whatIsNeeded?.name"></app-detail>

              <app-detail fxFlex="50" header="Podwójna rejestracja" [value]="registrationObject.doubleRegistration?.name"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Jaki egzamin potrzebny" [value]="registrationObject.missingExam?.name"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="IC_WITH_SALES_PROFILES.includes(registrationObject?.insuranceCompany?.key)">
              <div fxFlex="100">
                <app-detail header="Profile/systemy sprzedażowe">
                  <mat-chip-list>
                    <ng-container *ngFor="let salesProfile of registrationObject.salesProfiles; let last = last">
                      <mat-chip color="accent" selected>{{salesProfile.name}}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Numer RAU">
                  <mat-chip-list>
                    <ng-container *ngFor="let rauNumber of registrationObject.ofwca?.rauNumbers;">
                      <mat-chip color="accent" selected>{{rauNumber.rau}}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>

            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Blokada sprzedaży</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail-bool fxFlex="50" header="Wysłane do TU"
                               [value]="registrationObject.sentToBlock"></app-detail-bool>
              <app-detail-bool fxFlex="50" header="Zablokowane"
                               [value]="registrationObject.blocked"></app-detail-bool>
            </div>
            <div fxLayout="row" *ngIf="registrationObject.blockReason">
              <app-detail fxFlex="100" header="Powód zablokowania" [value]="registrationObject.blockReason"></app-detail>
            </div>
          </mat-card>
        </div>
      </div>

<!--      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="CHRONIE_INSURANCE_COMPANIES.includes(registrationObject?.insuranceCompany?.key)">-->
<!--        <div fxFlex="100">-->
<!--          <mat-card>-->
<!--            <div fxLayout="row">-->
<!--              <h3>Chronie.pl</h3>-->
<!--            </div>-->

<!--            <div fxLayout="row" fxLayoutGap="15px">-->
<!--              <app-detail fxFlex="50" header="Login" [value]="registrationObject.ofwca?.chronieLogin"></app-detail>-->

<!--              <app-detail fxFlex="50" header="Kod zniżkowy" [value]="registrationObject.ofwca?.chronieDiscountCode"></app-detail>-->
<!--            </div>-->

<!--            <div fxLayout="row">-->
<!--              <div fxFlex="100">-->
<!--                <app-detail header="Numer RAU">-->
<!--                  <mat-chip-list>-->
<!--                    <ng-container *ngFor="let rauNumber of registrationObject.ofwca.rauNumbers;">-->
<!--                      <mat-chip [color]="registrationObject.ofwca.rauNumbers.length === 1 ? 'accent' : 'warn'" selected>{{rauNumber.rau}}</mat-chip>-->
<!--                    </ng-container>-->
<!--                  </mat-chip-list>-->
<!--                </app-detail>-->
<!--              </div>-->
<!--            </div>-->

<!--          </mat-card>-->
<!--        </div>-->
<!--      </div>-->

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="registrationObject?.insuranceCompany?.key === IC_LINK4">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane do rejestracji Link 4</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="NIP" [value]="registrationObject.registrationNip"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Wlaściciel OFWCA Partner (Imię i Nazwisko, jeśli nie ma Właściciela to imię i nazwisko Koordynatora)"
                          [value]="registrationObject.registrationOfwcaOwner"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Nazwa Firmy Partner"
                          [value]="registrationObject.registrationCompanyName"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Email podstawowy Partnera"
                          [value]="registrationObject.registrationPartnerEmail"></app-detail>
            </div>

            <div fxLayout="row" *ngIf="registrationObject.registrationFacilityAddress">
              <app-detail-address fxFlex="100" header="Adres Placówki" [address]="registrationObject.registrationFacilityAddress"></app-detail-address>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="registrationObject?.insuranceCompany?.key === IC_PZU ||registrationObject.insuranceCompany.key === IC_PZU_LIFE">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>{{registrationObject?.insuranceCompany?.key === IC_PZU ? 'Dane do weryfikacji PZU': 'Dane do weryfikacji PZU Życie'}}</h3>
            </div>

            <div fxLayout="row" *ngIf="registrationObject.registrationFacilityAddress ||registrationObject.registrationFacilityAddressPzu ">
            <app-detail-address fxFlex="100" header="Adres biura/Miejsce pracy OFWCA" [address]="registrationObject.registrationFacilityAddressPzu"></app-detail-address>
          </div>

            <mat-card>
              <div fxLayout="row">
                <h3>Dane podmiotu sprzedaży</h3>
              </div>

              <div fxLayout="row">
                <app-detail fxFlex="100" header="Nazwa agencji"
                            [value]="registrationObject.registrationAgencyName"></app-detail>
              </div>

              <div fxLayout="row">
                <app-detail fxFlex="100" header="NIP" [value]="registrationObject.registrationNip"></app-detail>
              </div>


            </mat-card>
          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="registrationObject?.insuranceCompany?.key === IC_PZU || registrationObject?.insuranceCompany?.key === IC_PZU_LIFE || registrationObject?.insuranceCompany?.key === IC_LINK4 ">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3 >Dane rejestracji</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Email" [value]="registrationObject.additionalEmail"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Numer telefonu" [value]="registrationObject.additionalPhone"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

<!--      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="registrationObject?.insuranceCompany?.key === IC_TRASTI">-->
<!--        <div fxFlex="100">-->
<!--          <mat-card class="partners-add-card">-->
<!--            <div fxLayout="row">-->
<!--              <h3>Dane do rejestracji Trasti</h3>-->
<!--            </div>-->

<!--            <div fxLayout="row">-->
<!--              <app-detail fxFlex="100" header="Unikatowy adres email"-->
<!--                          [value]="registrationObject.trastiEmail"></app-detail>-->
<!--            </div>-->

<!--          </mat-card>-->
<!--        </div>-->
<!--      </div>-->

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="registrationObject.cession">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Cesja</h3>
            </div>

            <div fxLayout="row">
              <app-detail header="Rejestracja" [value]="registrationObject.cession.insuranceCompany.name
                                          + ' ' + registrationObject.cession.ofwca.fullName"
                          [link]="registrationObject.cession ? ['/rejestracje/szczegoly', registrationObject.cession.uuid] : undefined">
              </app-detail>
            </div>



          </mat-card>
        </div>
      </div>


      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Uwagi</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="" [value]="registrationObject.note"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>



      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="registrationObject?.insuranceCompany?.key === IC_COMPENSA">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane do rejestracji Compensa</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Biuro Compensa" [value]="registrationObject.registrationCompensaOfficeNew?.name"></app-detail>
            </div>



          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="registrationObject?.insuranceCompany?.key === IC_COMPENSA_LIFE">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane do rejestracji Vienna Life</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Biuro" [value]="registrationObject.registrationCompensaLifeOffice?.name"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Szczegóły</h3>
            </div>

<!--            <div fxLayout="row" *ngIf="registrationObject.insuranceCompany.key === IC_ALLIANZ">-->
<!--              <app-detail-bool fxFlex="100" header="Certyfikat Allianz" [value]="registrationObject.hasAllianzCert"></app-detail-bool>-->
<!--              Certyfikat Allianz podglad-->
<!--            </div>-->

            <ng-container *ngIf="registrationObject.insuranceCompany.key === IC_PZU || registrationObject.insuranceCompany.key === IC_PZU_LIFE">
              <div fxLayout="row">
                <app-detail-bool fxFlex="100" header="Wysłano do weryfikacji PZU" [value]="registrationObject.sentToPzuForVerification"></app-detail-bool>
              </div>
              <div fxLayout="row">
                <app-detail-bool fxFlex="100" header="Zgoda na rejestrację w PZU" [value]="registrationObject.agreedToRegisterInPzu"></app-detail-bool>
              </div>
              <div fxLayout="row">
                <app-detail-bool fxFlex="100" header="Dodatkowa weryfikacja PZU " [value]="registrationObject.pzuVerificationSupplement"></app-detail-bool>
              </div>
              <div fxLayout="row">
                <app-detail-bool fxFlex="100" header="Zgody i oświadczenia w aplikacji kandydat" [value]="registrationObject.consentsAndDeclarations"></app-detail-bool>
              </div>
              <div fxLayout="row">
                <app-detail-bool fxFlex="100" header="Przerejestrowanie Link4" [value]="registrationObject.link4Reregistration"></app-detail-bool>
              </div>
              <div fxLayout="row" *ngIf="registrationObject.insuranceCompany.key === IC_PZU">
                <app-detail-bool fxFlex="100" header="Rejestracja Link4 + PZU ASF" [value]="registrationObject.link4PzuAsfRegistration"></app-detail-bool>
              </div>
            </ng-container>

            <ng-container *ngIf="[IC_INTER_POLSKA,IC_INTER_POLSKA_LIFE].includes(registrationObject.insuranceCompany.key)">
              <div fxLayout="row">
                <app-detail-bool fxFlex="100" header="Szkolenie wstępne" [value]="registrationObject.hasInitialTraining"></app-detail-bool>
              </div>
            </ng-container>

            <div fxLayout="row">
              <app-detail-bool fxFlex="100" header="Oświadczenia komplet" [value]="registrationObject.statements"></app-detail-bool>
            </div>

            <ng-container *ngIf="[IC_PZU_LIFE,IC_PZU].includes(registrationObject.insuranceCompany.key)">
              <div fxLayout="row">
                <app-detail-bool fxFlex="100" header="Zaimportowany do aplikacji kandydat" [value]="registrationObject.importedToCandidateApplication"></app-detail-bool>
              </div>
            </ng-container>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Data wpływu oświadczeń do centrali" [value]="registrationObject.dateOfReceiptOfStatements | date:'y-MM-dd'"></app-detail>

              <app-detail fxFlex="50" header="Data zapisania na egzamin" [value]="registrationObject.dateOfRegistrationForTheExam | date:'y-MM-dd'"></app-detail>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Data wysłania do rejestracji do TU" [value]="registrationObject.sentToInsuranceCompanyToRegisterDate | date:'y-MM-dd'"></app-detail>

              <app-detail fxFlex="50" header="Data zarejestrowania" [value]="registrationObject.dateOfRegistration | date:'y-MM-dd'"></app-detail>
            </div>

            <div fxLayout="row" *ngIf="!registrationObject.statements">
              <app-detail fxFlex="100" header="Brakujące oświadczenia" [value]="registrationObject.missingStatements"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail-bool fxFlex="100" header="Aktywne KRK" [value]="registrationObject.ofwca?.hasActiveKrk"></app-detail-bool>
            </div>

            <div fxLayout="row">
              <app-detail-bool fxFlex="100" header="Dyplom" [value]="registrationObject.ofwca?.hasDiploma"></app-detail-bool>
            </div>

            <div fxLayout="row" *ngIf="registrationObject.insuranceCompany?.type?.key === INSURANCE_TYPE_ASSETS">
              <app-detail-bool fxFlex="100" header="Zaświadczenie 100p" [value]="registrationObject.ofwca?.hasPassedExam100pAssets"></app-detail-bool>
            </div>

            <div fxLayout="row" *ngIf="registrationObject.insuranceCompany?.type?.key === INSURANCE_TYPE_LIFE">
              <app-detail-bool fxFlex="100" header="Zaświadczenie 100p" [value]="registrationObject.ofwca?.hasPassedExam100pLife"></app-detail-bool>
            </div>

            <div fxLayout="row">
              <app-detail-bool fxFlex="100" header="Zaświadczenie 40p" [value]="registrationObject.hasPassedExam40p"></app-detail-bool>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Typ TU" [value]="registrationObject.insuranceCompany?.type?.name"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Status upoważnienia" [value]="registrationObject.authorizationStatus?.name"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Data wygenerowania upoważnienia" [value]="registrationObject.authorizationGeneratedAt | date:'y-MM-dd'"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Regionalny (majątek) OFWCA"
                          [value]="registrationObject.assetsRegional?.fullName"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Regionalny (życie) OFWCA"
                          [value]="registrationObject.lifeRegional?.fullName"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="registrationObject.insuranceCompany.registrationIdTypes.includes(REGISTRATION_ID_TYPE_SENT)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Podwójna rejestracja</h3>
            </div>

            <div fxLayout="row" fxLayoutAlign=" center">

              <div fxFlex="48" >
                    <app-detail-bool  [header]="registrationIdTypes[REGISTRATION_ID_TYPE_SENT]?.name"  [value]="registrationIdentifiers[REGISTRATION_ID_TYPE_SENT]?.value.toLowerCase() === 'tak'"></app-detail-bool>
              </div>
              <div  fxFlex="48" *ngIf="registrationIdentifiers[REGISTRATION_ID_TYPE_SENT]?.value.toLowerCase() === 'tak' && registrationIdentifiers[REGISTRATION_ID_TYPE_SENT]?.updatedAt">
                <app-detail fxFlex="100" header="Data dostarczenia" [value]="registrationIdentifiers[REGISTRATION_ID_TYPE_SENT].updatedAt | date:'y-MM-dd'"></app-detail>
              </div>
              <div  fxFlex="48" *ngIf="registrationIdentifiers[REGISTRATION_ID_TYPE_SENT]?.value.toLowerCase() === 'tak' && !registrationIdentifiers[REGISTRATION_ID_TYPE_SENT]?.updatedAt">
                <app-detail fxFlex="100" header="Data dostarczenia" [value]="registrationIdentifiers[REGISTRATION_ID_TYPE_SENT].createdAt | date:'y-MM-dd'"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutAlign=" center" *ngIf="registrationObject.insuranceCompany.registrationIdTypes.includes(REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT)">

              <div fxFlex="48" >
                <app-detail-bool  [header]="registrationIdTypes[REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT]?.name"  [value]="registrationIdentifiers[REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT]?.value.toLowerCase() === 'tak'"></app-detail-bool>
              </div>
              <div  fxFlex="48" *ngIf="registrationIdentifiers[REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT]?.value.toLowerCase() === 'tak' && registrationIdentifiers[REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT]?.updatedAt">
                <app-detail fxFlex="100" header="Data wysłania" [value]="registrationIdentifiers[REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT].updatedAt | date:'y-MM-dd'"></app-detail>
              </div>
              <div  fxFlex="48" *ngIf="registrationIdentifiers[REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT]?.value.toLowerCase() === 'tak' && !registrationIdentifiers[REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT]?.updatedAt">
                <app-detail fxFlex="100" header="Data wysłania" [value]="registrationIdentifiers[REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT].createdAt | date:'y-MM-dd'"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutAlign=" center" *ngIf="registrationObject.insuranceCompany.registrationIdTypes.includes(REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION)">

              <div fxFlex="48" >
                <app-detail-bool  [header]="registrationIdTypes[REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION]?.name"  [value]="registrationIdentifiers[REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION]?.value.toLowerCase() === 'tak'"></app-detail-bool>
              </div>
              <div  fxFlex="48" *ngIf="registrationIdentifiers[REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION]?.value.toLowerCase() === 'tak' && registrationIdentifiers[REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION]?.updatedAt">
                <app-detail fxFlex="100" header="Data uzyskania zgody" [value]="registrationIdentifiers[REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION].updatedAt | date:'y-MM-dd'"></app-detail>
              </div>
              <div  fxFlex="48" *ngIf="registrationIdentifiers[REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION]?.value.toLowerCase() === 'tak' && !registrationIdentifiers[REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION]?.updatedAt">
                <app-detail fxFlex="100" header="Data uzyskania zgody" [value]="registrationIdentifiers[REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION].createdAt | date:'y-MM-dd'"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutAlign=" center">

              <div fxFlex="100" >
                <app-detail  [header]="'Aktualny podmiot rejestracji'"
                             [value]="registrationObject.currentEntityOfRegistration"></app-detail>
              </div>

            </div>

            <div fxLayout="row" fxLayoutAlign=" center">

              <div fxFlex="100" >
                <app-detail  [header]="'Uwagi'"
                             [value]="registrationObject.comments"></app-detail>
              </div>

            </div>

            <div *ngIf="registrationObject.documentAnotherMulti" fxLayout="row" fxLayoutAlign=" center">
              <app-detail-bool fxFlex="33" header="Skan" [value]="registrationObject.documentAnotherMulti.documentInformationScan"></app-detail-bool>
              <app-detail-bool fxFlex="33" header="Oryginał" [value]="registrationObject.documentAnotherMulti.documentInformationOriginal"></app-detail-bool>
              <app-detail-bool fxFlex="33" header="Brak dokumentu" [value]="registrationObject.documentAnotherMulti.documentInformationDocumentMissing"></app-detail-bool>
            </div>

            <div fxLayout="row" fxLayoutAlign=" center">
              <app-detail-bool fxFlex="33" header="Brak dokumentu" [value]="registrationObject.registrationDocumentMissing"></app-detail-bool>
            </div>

          </mat-card>
        </div>
      </div>




      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="DEREGISTER_STATUSES.includes(registrationObject.status.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Wyrejestrowanie</h3>
            </div>

            <div fxLayout="row">
              <app-detail-bool fxFlex="100" header="Zgoda ASF na wyrejestrowanie" [value]="registrationObject.agreedToDeregister"></app-detail-bool>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Powód wyrejestrowania" [value]="registrationObject.deregisterReason"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>


    </div>

  </div>
</div>
